<form class="filter-shell" (submit)="onSearch($event)">
  <section class="filter-accordion">
    <button
      type="button"
      class="filter-accordion-header"
      (click)="toggle()"
      [attr.aria-expanded]="expanded"
      aria-controls="filter-panel-body"
    >
      <span class="filter-accordion-title">{{ title }}</span>
      <span class="filter-accordion-toggle-label">{{ expanded ? 'ocultar' : 'mostrar' }}</span>
    </button>

    <div class="filter-accordion-body" id="filter-panel-body" *ngIf="expanded">
      <div class="filter-panel-search">
        <ng-content select="[filter-search]"></ng-content>
      </div>

      <div class="filter-panel-fields">
        <ng-content select="[filter-fields]"></ng-content>
      </div>

      <div class="filter-panel-footer">
        <div class="filter-panel-footer-extra">
          <ng-content select="[filter-actions-extra]"></ng-content>
        </div>
        <div class="filter-panel-footer-actions">
          <button
            type="button"
            class="ui-btn ui-btn--secondary"
            (click)="onClear()"
          >
            Limpar filtros
          </button>
          <button type="submit" class="ui-btn ui-btn--primary">Buscar</button>
        </div>
      </div>
    </div>
  </section>
</form>
